import { CircularProgress } from '@mui/material';
import './Splash.scss';

const Splash = () => (
    <div className="core--splash-screen">
        <CircularProgress color="inherit" />
    </div>
);

export default Splash;
